<template>
  <div style="flex-basis: 30%">
      <StatItem v-if="viewCount" label="Views">{{ viewCount }}</StatItem>

      <StatItem v-if="video.isVisible" label="Video Share Link">
        <ClipboardLink :content="shareLink">
          <template #link>
            <a href="javascript:void(0)">Copy Link</a>
          </template>

          <template #success>Copied to clipboard</template>
        </ClipboardLink>
      </StatItem>

      <StatItem v-if="competitionDate" label="Competition Date">{{ competitionDate }}</StatItem>

      <StatItem label="Uploaded">{{ uploadDate }}</StatItem>

      <StatItem label="Source">{{ source }}</StatItem>
    </div>
</template>

<script>
import StatItem from "./StatItem"
import ClipboardLink from "@/components/ClipboardLink"
import moment from "moment"
import { mapState } from "vuex"
import isMobileApp from "@/utils/isMobileApp"

const formatDate = date => moment(date).format("MMMM D, YYYY")

const makeShareLink = (videoId, urlSlug) => {
  const baseUrl = new URL(
    isMobileApp() ? `https://sportsrecruits.com/athlete/${urlSlug}` : window.location.href,
  )
  if (baseUrl.pathname === "/video") {
    baseUrl.pathname = `/athlete/${urlSlug}`
  }
  baseUrl.searchParams.set("video", videoId)
  return baseUrl.href
}

export default {
  components: {
    ClipboardLink,
    StatItem,
  },

  props: {
    video: { type: Object, required: true },
  },

  computed: {
    ...mapState({
      userId: state => state.videoLibrary.userId,
      urlSlug: state => state.videoLibrary.urlSlug,
    }),
    videoId() {
      return this.video.id
    },

    viewCount() {
      return this.video.viewCount
    },

    shareLink() {
      return this.video.isVisible && makeShareLink(this.videoId, this.urlSlug)
    },

    competitionDate() {
      return this.video.frontRowVideo &&
        this.video.frontRowVideo.competitionDate
        ? formatDate(this.video.frontRowVideo.competitionDate)
        : null
    },

    uploadDate() {
      return formatDate(this.video.createdDate)
    },

    source() {
      if (this.video.videoSource) {
        return this.video.videoSource
      } else if (["kaltura", "legacy", "aws", "reel", "video_project_published_video", "video"].includes(this.video.host)) {
        return this.$domain.config('title_name', 'SportsRecruits')
      } else if (this.video.host == "youtube") {
        return "YouTube"
      } else {
        return this.video.host
      }
    },
  },
}
</script>